var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inputValue
    ? _c(
        "v-layout",
        {
          staticClass: "my-2 pr-1 flex-nowrap",
          style: {
            width: _vm.inputFieldSize + "%"
          },
          attrs: { column: "" }
        },
        [
          _vm.inputType !== "group" && _vm.label !== ""
            ? _c("label", { staticClass: "title-field" }, [
                _vm._v("\n    " + _vm._s(_vm.label) + ":\n  ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "value-field" }, [
            _vm._v(_vm._s(_vm.inputValue))
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cd343d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd343d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Forms/_Molecules/NetworkFields.vue
// module id = null
// module chunks = 